import { render, staticRenderFns } from "./UserListFooter.vue?vue&type=template&id=4ff6ba29&scoped=true"
import script from "./UserListFooter.vue?vue&type=script&lang=ts"
export * from "./UserListFooter.vue?vue&type=script&lang=ts"
import style0 from "./UserListFooter.vue?vue&type=style&index=0&id=4ff6ba29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff6ba29",
  null
  
)

export default component.exports